import { addError } from '@shared/utils/logger';
import { getConfig } from '../../../config/config';

const { locationServiceUri, locationServiceApiKey } = getConfig();

const logError = (message: string, details: unknown) => {
  addError(`[Timezone] ${message}`, {
    details,
  });
};

interface TimezoneResponse
  extends Readonly<{
    status: string;
    timeZoneId?: string;
    timeZoneName?: string;
    dstOffset?: number;
    rawOffset?: number;
    error_message?: string;
  }> {}

export const getTimezoneFromCoordinates = async (lat: number, lng: number, signal?: AbortSignal): Promise<string | null> => {
  if (!locationServiceUri) {
    logError('locationServiceUri is not configured', { lat, lng });
    return null;
  }

  if (!locationServiceApiKey) {
    logError('locationServiceApiKey is not configured', { lat, lng });
    return null;
  }

  try {
    const params = {
      location: `${lat},${lng}`,
      key: locationServiceApiKey,
    };

    // eslint-disable-next-line compat/compat
    const searchParams = new URLSearchParams(params);
    const url = `${locationServiceUri}/timezone/json?${searchParams}`;

    const response = await fetch(url, { signal });

    if (!response.ok) {
      logError('Timezone lookup failed', { error: response.statusText, lat, lng });
      return null;
    }

    const result = (await response.json()) as TimezoneResponse | null;

    if (result?.status === 'OK' && result?.timeZoneId) {
      return result.timeZoneId;
    }

    if (result?.error_message) {
      logError('Timezone lookup failed', { error: result.error_message, status: result.status, lat, lng });
    }

    return null;
  } catch (error) {
    logError('Failed to fetch timezone', { error, lat, lng });
    return null;
  }
};
